import * as triangleBuffer from '@/three/buffer-geometries/triangleAdvanced.js'

export default class SelectFrame {
  constructor (THREE, height, dikte, degrees, degreesOther) {
    this.THREE = THREE
    this.height = height
    this.dikte = dikte
    this.degrees = degrees
    this.degreesOther = degreesOther
    this.selectbox = null
    this.bouw(THREE, height, dikte, degrees, degreesOther)
  }

  bouw(THREE, height, dikte, degrees, degreesOther) {

    // geometry
    
    const geometry = new THREE.BufferGeometry()
    geometry.setAttribute( 'position', new THREE.BufferAttribute( new Float32Array(triangleBuffer.positionBuffer(height, dikte, degrees, degreesOther)), 3))
    geometry.setAttribute( 'uv', new THREE.BufferAttribute( new Float32Array(triangleBuffer.uvBuffer(height, dikte, degrees, degreesOther, 1000, 1000)), 2))
    geometry.computeVertexNormals()
    geometry.groups = triangleBuffer.groupBufferSelectFrame()

    // texture
    const transparent = new this.THREE.MeshBasicMaterial({ 
      color: 0xffffff,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.0,
      depthWrite: false,
    });

    const gradient = new THREE.ShaderMaterial({
  uniforms: {
    color1: {
      value: new THREE.Color("#ffffff")
    },
    baseLeft: {
      value: height/Math.tan(degrees * Math.PI / 180)
    },
    baseRight: {
      value: height/Math.tan(degreesOther * Math.PI / 180)
    },
    height: {
      value: height
    },
    angleLeft: {
      value: degrees * Math.PI / 180
    },
    angleRight: {
      value: degreesOther * Math.PI / 180
    },
    border: {
      value: 100.0
    }
  },
  vertexShader: `
    varying vec3 pos;
    varying vec2 vUv;

    void main() {
      vUv = uv;
      pos = position;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    uniform vec3 color1;
    uniform float baseLeft;
    uniform float baseRight;
    uniform float height;
    uniform float angleLeft;
    uniform float angleRight;
    uniform float border;

    varying vec2 vUv;
    varying vec3 pos;
    
    void main() {
      // Calculate distance to bottom edge
      float bottomDistance = pos.y;
      
      // Calculate distance to sloped edges
      float leftSlopeDistance = (height - ((height/baseLeft) * abs(pos.x)) - pos.y) * cos(angleLeft);
      float rightSlopeDistance = (height - ((height/baseRight) * abs(pos.x)) - pos.y) * cos(angleRight);
      
      // Choose the correct slope distance based on position
      float slopeDistance = pos.x < 0.0 ? leftSlopeDistance : rightSlopeDistance;
      
      // Take the minimum distance to any edge (closest edge)
      float distanceToEdge = min(bottomDistance, slopeDistance);
      
      // Create fade effect: full opacity at edges, transparent at border distance inward
      float alpha = 1.0 - smoothstep(0.0, border, distanceToEdge);
      
      gl_FragColor = vec4(color1, alpha);
    }
  `,
  transparent: true,
  side: THREE.DoubleSide,
  depthWrite: false,
});

    // mesh
    const selectbox = new THREE.Mesh(geometry, [
      gradient,
      gradient,
      transparent,
      transparent,
      transparent,
    ])
    selectbox.name = "topgevelSelectbox"
    selectbox.visible = false

    this.selectbox = selectbox
  }

  update (height, dikte, degrees, degreesOther) {
    // UPDATE FUNCTIE DEPRECATED
    // FUNCTIE WERKT NITE MEER GOED NA UPDATEN THREEJS
    // NU MOET GEWOON STEEDS EEN NIEUWE SELECTBOX WORDEN AANGEMAAKT

    this.selectbox.geometry.attributes.position.array = new Float32Array(triangleBuffer.positionBuffer(height, dikte, degrees, degreesOther))
    this.selectbox.geometry.attributes.position.needsUpdate = true

    const gradient = new this.THREE.ShaderMaterial({
      uniforms: {
        color1: {
          value: new this.THREE.Color("#ffffff")
        },
        base: {
          value: height/Math.tan(degrees * Math.PI / 180)
        },
        height: {
          value: height
        },
        angle: {
          value: degrees * Math.PI / 180
        }
      },
      vertexShader: `
        varying vec3 pos;
    
        void main() {
          pos = position;
          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
      `,
      fragmentShader: `
        uniform vec3 color1;
        uniform float base;
        uniform float height;
        uniform float angle;

        float border = 100.0;
        varying vec3 pos;
        
        void main() {
          float distanceToBorder = min(pos.y <= border ? pos.y : 1000.0, (height-((height/base)*abs(pos.x)) - pos.y) * cos(angle));
          float alpha = smoothstep(border, 0.0, distanceToBorder);
          gl_FragColor = vec4(color1, alpha);
        }
      `,
      transparent: true,
      side: this.THREE.DoubleSide,
      depthWrite: false,
    });

    this.selectbox.material[0] = gradient
    this.selectbox.material[1] = gradient

    this.selectbox.geometry.computeBoundingBox()
    this.selectbox.geometry.computeBoundingSphere();
  }
}